module.exports = __webpack_public_path__ + "img/people-gelb-neu.ec4bb45d.svg";